<template>
  <div>
    <x-grid :id="'formList'"
            :rowId="rowId"
            :columns="columns"
            :toolbar-config="toolbarConfig"
            ref="grid"
            :editable="true"
            :edit-rules="editRules"
            :treeConfig="treeConfig"
            :ajaxConfig="ajaxConfig"
            :cellDbClick="cellDbClick"
            @toolbar-addData="addRow"
    >
      <template v-slot:[toolbarConfig.templatelSlots]>
        <vxe-button @click="addGroup">
          <a-icon type="diff"/>
          新增
        </vxe-button>
        <vxe-button @click="refresh">
          <a-icon type="redo"/>
          刷新
        </vxe-button>
      </template>

      <template v-slot:operate="{row}">
        <vxe-button style="margin-right: 10px" size="mini" status="primary" @click="addGroup(row)">新增子类型</vxe-button>
        <vxe-button style="margin-right: 10px" size="mini" status="primary" @click="updateGroup(row)">修改</vxe-button>
        <vxe-button style="margin-right: 10px" size="mini" @click="deleteGroup(row)">删除</vxe-button>

        <!--        <btn-confirm-->
        <!--            title="确定要删除吗?"-->
        <!--            @confirm="delRow(row)"-->
        <!--        >-->
        <!--          <vxe-button size="mini">删除</vxe-button>-->
        <!--        </btn-confirm>-->
        <!--                <btn-confirm-->
        <!--                    title="确定要删除吗?"-->
        <!--                    @confirm="deleteGroup(row)"-->
        <!--                >-->
        <!--                  <vxe-button size="mini">删除</vxe-button>-->
        <!--                </btn-confirm>-->

      </template>

    </x-grid>


    <a-modal
        title="活动详情"
        centered
        :closable="false"
        :footer="null"
        :maskClosable="false"
        :visible="editModalVisible"
        :width="800"
    >
      <detailForm
          :row="row"
          :parentId="parentId"
          :typeId="typeId"
          :showDesc="showDesc"
          :readyTodo="readyTodo"
          :rowId="editRowId"
          v-if="editModalVisible"
          ref="detailForm"
          @cancelled="closeEdit()"
          @saved="closeEdit(true)">
      </detailForm>
    </a-modal>

  </div>
</template>

<script>
import XGrid from '@/components/grid/XGridTree'
import {GridTreeMinix} from '@/utils/GridTreeMixin'
import {
  formatter as fmt
} from "@/utils/ebase-formatter"

console.info(fmt);//防止未用到报未定义错误 用到了可删除
import api from '@/services/api';

const fac = XGrid.factory;
//私有化组件
import detailForm from "@/pages/web/activityManage/activityType/activityTypeDetail";
import {dataApi} from "@/services/activityManage/activityType";
import {XEUtils} from "@/utils/common/FormBase";

//主键
const rowId = 'typeId';

// const delUrl = api.comm.MENU;
const url = api.activity.ACTIVITYTYPEALL;

//查询表格
const ajaxConfig = fac.makeAjaxConfig(url, rowId);
console.log('ajaxData', ajaxConfig)

// ajaxConfig.forEach(item=>{
//   item.parentId = item.parentId
// })


const treeConfig = fac.makeTreeConfig();
console.log('ajaxData', treeConfig)


//列
const columns = [
  fac.makeColumnCheckboxDefault(),
  fac.makeColumn({
    field: "typeName",
    title: "活动类型",
    width: 200,
    treeNode: true,
  }),
  fac.makeColumn("typeDesc", "活动描述", 200),
  fac.makeColumn({
    title: "操作",
    width: 260,
    slots: {
      default: 'default'
    },
  }),
]

//工具栏按钮
const toolbarConfig = fac.makeToolbarConfig({
  templatelSlots: 'toolbarBtns'
});

//可编辑表格约束
const editRules = fac.makeEditRules(columns);

export default {
  mixins: [GridTreeMinix],
  components: {
    detailForm

  },
  data() {
    return {
      url,
      rowId,
      editRules,
      ajaxConfig,
      treeConfig,
      // delUrl,
      toolbarConfig,
      columns,
      parentId: 0,
      typeDesc: '',
      typeName: '',
      typeId: '',
      showDesc:false,

    }
  },
  // authorize: {
  //   addRow: 'ADD',
  //   updateRow:'UPDATE',
  //   delRow:'DELETE'
  // },
  // methods:{},
  methods: {
    // 新增活动类型
    addGroup(row) {
      this.row = row
      this.typeId = row.typeId
      if(!row.parent){//如果没有父亲，没有描述
        this.parentId = row.typeId

        console.log('主页的parent===========================================' + this.parentId)

      }
      else  this.parentId = row.parentId
      this.readyTodo = false;
      this.editModalVisible = true;
      if(row.typeId){
        this.showDesc=true
      }

    },
    closeEdit() {
      this.editModalVisible = false;
    },
    // 修改活动类型
    updateGroup(row) {
      console.log(row)
      this.parentId = row.typeId || row.parentId||0
      this.row = row
      this.typeId=row.typeId
      this.readyTodo = true;
      this.editModalVisible = true;
      if(row.typeDesc)
        this.showDesc=true
      // this.typeDesc=row.typeDesc
      // this.typeName=row.typeName



    },
    // 删除活动类型
    async deleteGroup(row) {
      console.log('row=====================================================')
      console.log(row)
      let vm = this;
      console.log('vm========================================================')
      console.log(vm)

      //没有子节点才能删除
      // if (row.parentId) {
        // vm.$message.error('此节点包含子节点，不能删除');
      // } else
        if (row.children.length) {
        vm.$message.error('此节点包含子节点，不能删除');
      } else {
        vm.$confirm({
          title: '确认删除？',
          async onOk() {
            // vm.loading(true);
            let entity = await dataApi.deleteActType(row.typeId); //删除
            if (entity.code === 200) {
              vm.$message.success('删除成功');
              location.reload()
              vm.getTypeList();

              // vm.loading(false);
              vm.refresh();
              row.parentId = 0;
              row.typeId = '';
              row.selectedObj = {};
            } else if (entity.code === 201) {
              vm.$message.warn(entity.data);
            }
            // vm.getTypeList();

          }
        })
      }
    },
      // 获取标签树的数据
      async getTypeList() {
        let typeList = await dataApi.getActType();
        this.allList = typeList.data;
        this.allList.map(item => {
          item.typeNameDesc = item.typeName + (item.typeDesc ? '\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0' + item.typeDesc : '')
        })
        this.typeList = XEUtils.toArrayTree(typeList.data, {
          key: 'typeId',
          parentKey: 'parentId',
          children: 'children'
        })
        if (typeList.data.length) {
          // this.defaultExpandedKeys = typeList.data.map(val => {
          //   //默认只展开一级
          //   if (val.typeId == 0) { //已确定测试、正式系统最大一层typeId都是1
          //     return val.typeId
          //   }
          //   // return val.typeId
          // })
        }
  },
  //   /**
  //    * 选中树
  //    * @param selectedKeys
  //    */
  //   onSelect(selectedKeys) {
  //     this.selectedKeys = selectedKeys;
  //     this.typeId = selectedKeys[0];
  //     let idx = this.allList.findIndex(item => {
  //       return item.typeId === this.typeId;
  //     })
  //     this.parentId = this.allList[idx]?.parentId;
  //     this.selectedObj = this.allList[idx];
  //     //右侧显示
  //     this.typeName = this.selectedObj.typeName
  //     this.typeRemark = this.selectedObj.typeDesc
  //   },
  //   /**
  //    * 选择复选框
  //    * @param checkedKeys
  //    */
  //   onCheck(checkedKeys) {
  //     this.checkedKeys = checkedKeys.checked;
  //   },
  //
  },
}
</script>

<style scoped>
</style>